export default __webpack_public_path__ + "static/media/email-verify.840d79fc.webp";